import React, { memo } from "react";

const Artist = memo(() => {
  return <div>Artist</div>;
});

export default Artist;
